export default "__VITE_ASSET__c2c5bnFB__"